import type { LineItem } from "./invoice";

export type RecurringCadence =
  | "WEEKLY"
  | "BIWEEKLY"
  | "MONTHLY"
  | "QUARTERLY"
  | "ANNUALLY";

export type RecurringStatus = "ACTIVE" | "PAUSED" | "CANCELLED" | "COMPLETED";

export interface RecurringInvoice {
  id: string;
  employee_id: string;
  employee_name?: string;
  title: string;
  line_items_json: LineItem[];
  tax_rate: number;
  currency: string;
  terms?: string;
  notes?: string;
  due_days_after_issue: number;
  cadence: RecurringCadence;
  start_date: string;
  end_date?: string;
  next_run_at: string;
  last_run_at?: string;
  occurrences_generated: number;
  max_occurrences?: number;
  status: RecurringStatus;
  auto_send: boolean;
  send_to_email?: string;
  created_at: string;
  updated_at: string;
}

export const CADENCE_LABELS: Record<RecurringCadence, string> = {
  WEEKLY: "Weekly",
  BIWEEKLY: "Every 2 weeks",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  ANNUALLY: "Annually",
};

export const RECURRING_STATUS_LABELS: Record<RecurringStatus, string> = {
  ACTIVE: "Active",
  PAUSED: "Paused",
  CANCELLED: "Cancelled",
  COMPLETED: "Completed",
};

export interface GeneratedRecurringInvoice {
  template_id: string;
  invoice_id: string;
  invoice_number: string;
  currency: string;
  total: number;
  auto_sent: boolean;
}

export interface RunDueResult {
  ran_at: string;
  generated: GeneratedRecurringInvoice[];
  completed_templates: string[];
}
